module.exports = __webpack_public_path__ + "img/signin-background.89fc72b3.png";